exports.assignRoutesToGroup = async function assignRoutesToGroup (state, { groupId, routeIdsByDestination }) {
  const snapshots = await state.dal.order.getGroup(state, { groupId, onlyIncompleteSnaps: true })
  const snapshotsToUpdate = snapshots.filter(snapshot => {
    return !snapshot.routeId && routeIdsByDestination[snapshot.destinationId]
  })

  return Promise.all(snapshotsToUpdate.map(snapshot => {
    return state.dal.order.update(state, {
      ...snapshot,
      routeId: routeIdsByDestination[snapshot.destinationId]
    })
  }))
}
